import React from "react";
import { CountryTableProps, CountryTableState } from "./models";

import { 
    Box, 
    IconButton, 
    Stack 
} from "@mui/material";
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from "@mui/icons-material/Edit";

import MaterialReactTable from 'material-react-table';
import type { MRT_ColumnDef } from 'material-react-table';
import { t } from "@lingui/macro";
import { Country } from "models";
import { ConfirmModal } from "commons/modal/confirm-modal";


export class CountryTable extends React.Component<CountryTableProps, CountryTableState>
{
    private tableColumns: MRT_ColumnDef[];

    public constructor(props: any) {

        super(props)

        this.state={
            openConfirmModal: false,
            countryToDelete: ""
        }

        this.tableColumns = [
            {
                header: t({
                    id: "ct-table-col-title",
                    message: "Paese"
                }),
                accessorKey: "value",
                Cell: ({ cell }) => {
                    return (
                        <Box>
                            {cell.getValue<string>()}
                        </Box>
                    );
                },
            },
        ];
    }

    private openConfirmModal = (id: string) : void =>{
        this.setState(() => ({
            openConfirmModal: true,
            countryToDelete: id
        }))
    }

    private cancelConfirmModalCallback = () : void =>{
        this.setState(() => ({
            openConfirmModal: false,
            countryToDelete: ""
        }))
    }

    private acceptConfirmModal = () : void =>{
        this.setState(() => ({
            openConfirmModal: false,
        }))
        this.deleteCountry()
    }

    private deleteCountry = (): void => {
        this.props.deleteCountry(this.state.countryToDelete);
        this.setState(() => ({
            countryToDelete: ""
        }))

    }

    private getIdValue = (row: any): string => {
        return row.original.id
    }

    private openEditModal = (country: any) => {
        this.props.openEditCountryTable(country as Country);
    }

    private handlePageChange = (updateFn: any) => {
        let newPagination = updateFn(this.props.pagination);
        this.props.updatePaginationCallBackFn(newPagination);
    } 

    render() {
        return (
            <>
            <Box style={{ maxWidth: '100%' }}>
                <MaterialReactTable
                    columns={this.tableColumns}
                    rowCount={this.props.totalCountryCount}
                    pageCount={Math.ceil(this.props.totalCountryCount / this.props.pagination.pageSize)}
                    data={this.props.countries}
                    enableRowSelection={false}
                    enableColumnOrdering={false}
                    enableColumnActions={false}
                    enableGlobalFilter={false}
                    enableFilters={false}
                    muiTableHeadCellProps={{
                        sx: {
                            color: "white",
                            backgroundColor: process.env.REACT_APP_PRIMARY_COLOR
                        }
                    }}
                    displayColumnDefOptions={{
                        'mrt-row-actions': {
                            header: ""
                        }
                    }}
                    enableRowActions
                    positionActionsColumn="last"
                    renderRowActions={({ row }) => (
                        <Stack direction={"row"} display={"flex"} justifyContent={"right"} >
                            <IconButton onClick={() => this.openEditModal(row.original)}>
                                <EditIcon />
                            </IconButton>
                            <IconButton onClick={() => this.openConfirmModal(this.getIdValue(row))}>
                                <DeleteIcon />
                            </IconButton>
                        </Stack>
                    )}
                    onPaginationChange={this.handlePageChange}
                    enableTopToolbar={false}
                    manualPagination={true}
                    autoResetPageIndex={false}
                    enableDensityToggle={false}
                    state={{
                        pagination: this.props.pagination
                    }} />
            </Box>
        {this.state.openConfirmModal && <ConfirmModal
            cancelConfirmCallback={this.cancelConfirmModalCallback}
            confirmCallback={this.acceptConfirmModal}
            text={"Sei sicuro di voler procedere con l'eliminazione del paese?"}
            textId={"ct-delete-country-text"}
        />}
    </>)
    }
}
